import React, { useEffect } from "react";
import "../style/noticationPanel.css";
import { icons } from "../../../../../svg";
import CloseIcon from "../../../../../components/CloseIcon";

interface NotificationPanelProps {
  title: string;
  message: string;
  onClose: () => void;
}

const NotificationPanel: React.FC<NotificationPanelProps> = ({
  title,
  message,
  onClose,
}) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000); // Automatically close after 5 seconds
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="notification-panel" role="alert" aria-live="polite">
      <div className="notification-header">
        <div className="notification-title-container">
          <img
            data-tooltip-id="GreenCheckMark"
            src={icons.GreenCheckMark}
            alt="Success"
            className="icon"
          />
          <span className="notification-title">
            <strong>{title}</strong>
          </span>
        </div>

        <span className="notification-close-btn">
          <CloseIcon onClick={onClose} />
        </span>
      </div>
      <div className="notification-message">{message}</div>
    </div>
  );
};

export default NotificationPanel;
